import styled from 'styled-components';

export default styled.div`
  width: ${props => props.volume || 0}%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: rgba(111, 88, 255, 1);
  border-radius: 1rem;
`;
